import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExternalLoginRoutingModule } from './external-login-routing.module';
import {
  ExternalInvitationLoginComponent
} from '@app/external-login/pages/external-login/external-invitation-login/external-invitation-login.component';
import { ExternalComponent } from '@app/external-login/pages/external-login/external/external.component';
import {FlexModule} from '@ngbracket/ngx-layout';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {PipesModule} from '@shared/pipes/pipes.module';
import {ReactiveFormsModule} from '@angular/forms';
import { ExternalOpenLoginComponent } from './pages/external-login/external-open-login/external-open-login.component';
import {SharedModule} from '@shared/shared.module';


@NgModule({
  declarations: [
    ExternalInvitationLoginComponent,
    ExternalComponent,
    ExternalOpenLoginComponent
  ],
    imports: [
        CommonModule,
        ExternalLoginRoutingModule,
        FlexModule,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        PipesModule,
        ReactiveFormsModule,
        SharedModule
    ]
})
export class ExternalLoginModule { }
